import { api } from '@/shared/api/client';
import type { FulfillCheckoutResponse } from '../model/dto';

export const postFulfillCheckout = async (payload: {
  session_id: string;
}): Promise<FulfillCheckoutResponse> => {
  const { data } = await api.post<FulfillCheckoutResponse>(
    '/stripe/fulfill_checkout/',
    payload,
  );
  return data;
};
